/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedBlurbShipping_shipment$ref = any;
export type PdpRespSidebarBlurbs_shipment$ref = any;
export type PdpRespSidebarBlurbs_shipment = {
    readonly " $fragmentRefs": PdpSharedBlurbShipping_shipment$ref;
    readonly " $refType": PdpRespSidebarBlurbs_shipment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSidebarBlurbs_shipment",
    "type": "Shipment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedBlurbShipping_shipment",
            "args": null
        }
    ]
} as any);
(node as any).hash = '0520c02ebca9269dca1924ae0618c8f7';
export default node;
